export const getRuntimeConfig = (): Record<string, string | undefined> => {
  // 1. Valores capturados no BUILD (estáticos)
  const staticEnvs: Record<string, string | undefined> = {
    NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    NEXT_PUBLIC_CHAT_API_BASE_URL: process.env.NEXT_PUBLIC_CHAT_API_BASE_URL,
    NEXT_PUBLIC_CONN_DETAILS_ENDPOINT: process.env.NEXT_PUBLIC_CONN_DETAILS_ENDPOINT,
    NEXT_PUBLIC_SHOW_SETTINGS_MENU: process.env.NEXT_PUBLIC_SHOW_SETTINGS_MENU,
    NEXT_PUBLIC_LK_RECORD_ENDPOINT: process.env.NEXT_PUBLIC_LK_RECORD_ENDPOINT,
    NEXT_PUBLIC_DATADOG_CLIENT_TOKEN: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
    NEXT_PUBLIC_DATADOG_SITE: process.env.NEXT_PUBLIC_DATADOG_SITE,
    NEXT_PUBLIC_NOTIFICATION_BASE_URL: process.env.NEXT_PUBLIC_NOTIFICATION_BASE_URL,
    NEXT_PUBLIC_NOTIFICATION_TOKEN: process.env.NEXT_PUBLIC_NOTIFICATION_TOKEN,
    NEXT_PUBLIC_DPS_URL: process.env.NEXT_PUBLIC_DPS_URL,
    NEXT_PUBLIC_MAX_VISIBLE_TILES: process.env.NEXT_PUBLIC_MAX_VISIBLE_TILES,
    NEXT_PUBLIC_SMARTCOACH_ALLOWED_EMAILS: process.env.NEXT_PUBLIC_SMARTCOACH_ALLOWED_EMAILS || process.env.SMARTCOACH_ALLOWED_EMAILS,
  };

  if (typeof window !== 'undefined') {
    // 2. Valores injetados no RUNTIME (pelo update-runtime-env.cjs)
    const runtimeConfig = (window as any).__RUNTIME_CONFIG__;

    if (runtimeConfig) {
      // O MERGE garante que o que está no window tenha prioridade,
      // mas mantém o que veio do build caso não esteja no window.
      return { ...staticEnvs, ...runtimeConfig };
    }
    return staticEnvs;
  }

  // Fallback para ambiente de servidor/Node (Docker)
  const publicEnvs: Record<string, string | undefined> = { ...staticEnvs };
  try {
    Object.keys(process.env).forEach((key) => {
      if (key.startsWith('NEXT_PUBLIC_')) {
        publicEnvs[key] = process.env[key];
      }
    });
  } catch (e) {}

  return publicEnvs;
};

export const getEnv = (key: string, defaultValue?: string): string | undefined => {
  const config = getRuntimeConfig();
  return config[key] ?? defaultValue;
};